import OnboardingBiometrics from '../../../onboarding/components/OnboardingBiometrics';

export default function OnboardingBiometricsScreen() {
    return <OnboardingBiometrics />;
}
